export enum ReportCardType {
  REPORT = 'ReportCardModel',
  VIDEO = 'VideoCardModel',
  EVENT = 'EventCardModel',
}
